/* eslint-disable react-hooks/exhaustive-deps */
import { Pagination, Table, Tag } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import IconBack from '../../../assets/Images/icons/icon-back';
import ConsentService from '../../../services/Consent.service';

export default function History() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    let { historyId } = useParams();
    const [historyInfo, setHistoryInfo] = useState([]);

    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
    });

    useEffect(() => {
        getHistoryDetail();
    }, [historyId]);

    const getHistoryDetail = async (pageValue) => {
        try {
            const { data } = await ConsentService.getHistoryDetail({
                consentHistoryId: historyId,
                p: pageValue.page ? pageValue.page : 1,
                ps: pageValue.pageSize ? pageValue.pageSize : 10,
            });
            setLoading(false);
            
            let consentHistoryDifResponse = data?.resultData?.consentHistoryDifResponse || [];
            
            const expiryTh = consentHistoryDifResponse.find(
                (item) => item.titleEn === "Expiry" && item.titleTh === "หมดอายุ"
            );
    
            const expiryEn = consentHistoryDifResponse.find(
                (item) => item.titleEn === "Expiry" && item.titleTh === "Expiry"
            );
            
            if (expiryTh && expiryEn) {
                expiryTh.oldValue = [...expiryEn.oldValue, ...expiryTh.oldValue];
                expiryTh.newValue = [...expiryEn.newValue, ...expiryTh.newValue];
                
                consentHistoryDifResponse = consentHistoryDifResponse.filter(
                    (item) => item.titleTh !== "Expiry"
                );
            }
            setHistoryInfo((prevInfo) => ({
                ...data?.resultData,
                consentHistoryDifResponse,
            }));
            
            setCurrentPage({
                page: data?.resultData.page,
                pageSize: data?.resultData.pageSize,
                total: data?.resultData.total,
            });
            
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };
    useEffect(() => {
        if (loading) {
            getHistoryDetail(currentPage);
        }
    }, [currentPage.page, currentPage.pageSize]);

    const _getTagStatus = (e) => {
        switch (e.status) {
            case 'Draft':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4"
                        style={{ color: '#9A9A9A', borderColor: '#9A9A9A' }}
                    >
                        {/* {i18n.language === 'en' ? e.statusEn : e.statusTh} */}
                        {e?.status} {e?.version}
                    </Tag>
                );
            case 'Published':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4 text-white"
                        style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                    >
                        {/* {i18n.language === 'en' ? e.statusEn : e.statusTh} */}
                        {e?.status} {e?.latestPublishVersion}
                    </Tag>
                );
            default:
                return '-';
        }
    };

    const columns = [
        {
            title: <div>{t('Title')}</div>,
            dataIndex: lang === 'en' ? 'titleEn' : 'titleTh',
            key: 'title',
            width: '34%',
        },
        {
            title: <div>{t('OldData')}</div>,
            dataIndex: 'oldValue',
            key: 'oldValue',
            width: '33%',
            render: (_, { oldValue }) => (
                <>
                    {oldValue?.length > 0 ? (
                        <p
                            className="text-gray-600 whitespace-pre-line px-2"
                            style={{ wordBreak: 'break-word' }}
                        >
                            {lang === 'en' ? oldValue[0] : (oldValue[1] ? oldValue[1] : oldValue[0]) }
                        </p>
                    ) : (
                        <div className="text-gray-600">-</div>
                    )}
                </>
            ),
        },
        {
            title: <div>{t('CurrentData')}</div>,
            dataIndex: 'newValue',
            key: 'newValue',
            width: '33%',
            render: (_, { newValue }) => (
                <>
                    {newValue?.length > 0 ? (
                        <p
                            className="text-gray-600 whitespace-pre-line px-2"
                            style={{ wordBreak: 'break-word' }}
                        >
                            {lang === 'en' ? newValue[0] : (newValue[1] ? newValue[1] : newValue[0]) }
                        </p>
                    ) : (
                        <div className="text-gray-600">-</div>
                    )}
                </>
            ),
        },
    ];

    return (
        <div>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        // navigate(`/risk-assessment/${riskId}/view`);
                        navigate(-1);
                    }}
                >
                    <IconBack />
                </div>
                {t('History')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Consent Management')} /{' '}
                </span>
                <span className="text-sm text-gray-400">
                    {t('common.Consent')} /{' '}
                </span>

                <span> {t('History')} </span>
            </div>
            <div className="bg-white rounded-xl p-4 my-4">
                <div className="grid grid-cols-2 p-4">
                    <div className="col-span-1">
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Name')} :
                            </div>
                            <div
                                className="col-span-8 pr-2"
                                style={{ wordBreak: 'break-word' }}
                            >
                                {/* {historyInfo?.historyName || '-'} */}
                                {/* {consentNameEn} */}
                                {i18n.language === 'en'
                                    ? historyInfo?.consentNameEn
                                    : historyInfo?.consentNameTh}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Type')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.consentType || '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('LogDate')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.logDate
                                    ? moment(historyInfo?.logDate).format(
                                          'DD/MM/YYYY HH:mm'
                                      )
                                    : '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Update By')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.logBy || '-'}
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1">
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Version')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.version || '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Status')} :
                            </div>
                            <div className="col-span-8">
                                <span>{_getTagStatus(historyInfo)}</span>
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Action')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.action ? (
                                    <Tag
                                        className="rounded-xl -my-1 text-center px-4 text-white"
                                        color="#7B67FB"
                                    >
                                        {i18n.language === 'en'
                                            ? historyInfo?.action
                                            : historyInfo?.action}
                                    </Tag>
                                ) : (
                                    <>-</>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-xl p-4">
                <Table
                    bordered
                    className="inbox_table"
                    dataSource={historyInfo?.consentHistoryDifResponse || []}
                    columns={columns}
                    pagination={false}
                />
            </div>
            <div className="w-full text-right mt-4">
                <Pagination
                    current={currentPage?.page || 1}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={currentPage?.pageSize}
                    total={currentPage?.total || 1}
                    onChange={(page, pageSize) => {
                        const pageValue = {
                            ...currentPage,
                            page: page,
                            pageSize: pageSize,
                        };
                        setLoading(true);
                        setCurrentPage(pageValue);
                    }}
                    showSizeChanger
                />
            </div>
        </div>
    );
}
